import React, { useRef } from "react";
import { v4 } from "uuid";

export const useShallowAbort = () => {
  const currentRequestId = useRef<string | null>(null);

  const onInitRequest = React.useCallback(() => {
    currentRequestId.current = v4();
  }, []);

  const onAbortRequest = React.useCallback(() => {
    currentRequestId.current = null;
  }, []);

  const runWithCurrentRequest = React.useCallback(
    (func: () => void) => {
      if (currentRequestId.current !== null) {
        func();
      }
    },
    [currentRequestId]
  );

  const getIsAborted = () => currentRequestId.current === null;

  return {
    getIsAborted,
    onInitRequest,
    onAbortRequest,
    runWithCurrentRequest,
  };
};
